import type { ParallaxControllerOptions } from 'parallax-controller'
import { ParallaxController } from 'parallax-controller'

interface ParallaxPlugin {
  init: (options?: ParallaxControllerOptions) => ParallaxController
  disable: () => void
  getController: () => ParallaxController | never
}

declare module '#app' {
  interface NuxtApp {
    $parallax: ParallaxPlugin
  }
}

declare module 'vue' {
  interface NuxtApp {
    $parallax: ParallaxPlugin
  }
}

const defaultOptions: ParallaxControllerOptions = {
  scrollAxis: 'vertical'
}

export default defineNuxtPlugin(() => {
  let controller: ParallaxController

  const preferReducedMotion = usePreferredReducedMotion()

  const init = (options: ParallaxControllerOptions = {}) => {
    if (!controller) {
      controller = ParallaxController.init({
        ...defaultOptions,
        ...options,
        disabled: preferReducedMotion.value === 'reduce'
      })
      return controller
    }

    return controller
  }

  const getController = () => {
    if (!controller) {
      log.warn('ParallaxController is not initialized. Please call init() first.')
    }

    return controller
  }

  return {
    provide: {
      parallax: {
        init,
        getController,
      }
    }
  }
})
